import SettingsContent from '../Wrapper.vue';
import Index from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/schoolClasses'),
      roles: ['administrator'],
      component: SettingsContent,
      props: {
        headerTitle: 'SCHOOL_CLASSES.HEADER',
        icon: 'book-contacts',
        showNewButton: true,
      },
      children: [
        {
          path: '',
          name: 'school_classes_wrapper',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'school_classes_list',
          component: Index,
          roles: ['administrator'],
        },
      ],
    },
  ],
};
